/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directionality } from "@angular/cdk/bidi";
import { Directive, Input, ChangeDetectorRef, Optional, Inject, ContentChildren, QueryList } from "@angular/core";
import { RouterLink, RouterLinkWithHref, Router } from "@angular/router";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzMenuItemDirective } from "ng-zorro-antd/menu";
import { UiMenuService } from "../services/menu.service";
import { UiSubmenuService } from "../services/submenu.service";
import { UiIsMenuInsideDropDownToken } from "../utils/menu.utils";

@Directive({
  selector: "[ui-menu-item]",
  exportAs: "uiMenuItem",
})
export class UiMenuItemDirective extends NzMenuItemDirective {
  @Input("uiPaddingLeft") public nzPaddingLeft?: number;
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiSelected") @InputBoolean() public nzSelected = false;
  @Input("uiDanger") @InputBoolean() public nzDanger = false;
  @Input("uiMatchRouterExact") @InputBoolean() public nzMatchRouterExact = false;
  @Input("uiMatchRouter") @InputBoolean() public nzMatchRouter = false;
  @ContentChildren(RouterLink, { descendants: true }) public listOfRouterLink!: QueryList<RouterLink>;
  @ContentChildren(RouterLinkWithHref, { descendants: true }) public listOfRouterLinkWithHref!: QueryList<RouterLinkWithHref>;

  public constructor(
    uiMenuService: UiMenuService,
    cdr: ChangeDetectorRef,
    @Optional() uiSubmenuService: UiSubmenuService,
    @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean,
    @Optional() directionality: Directionality,
    @Optional() routerLink?: RouterLink,
    @Optional() routerLinkWithHref?: RouterLinkWithHref,
    @Optional() router?: Router
  ) {
    super(uiMenuService, cdr, uiSubmenuService, isMenuInsideDropDown, directionality, routerLink, routerLinkWithHref, router);
  }
}
